import { Component, HostListener, Input, OnInit, signal } from '@angular/core';
import { GlobalService } from '../../shared/service/global.service';

@Component({
    selector: 's2-shared-knox-events',
    templateUrl: './knox-events.component.html',
    styleUrls: ['./knox-events.component.scss'],
    standalone: false
})
export class KnoxEventsComponent implements OnInit {

    @Input() knoxEvents!: [];
    isMobile = signal<boolean>(false);
    @HostListener('window:resize') onResize() { this.isMobile.set(GlobalService.setIsMobile(window.innerWidth)); }
    ngOnInit() { this.isMobile.set(GlobalService.setIsMobile(window.innerWidth)); }
}
